"use client";
import {
  EventScheduledEvent,
  PopupModal,
  useCalendlyEventListener,
} from "react-calendly";

export interface ClientUserData {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}

interface CalendlyPopupProps {
  url: string;
  prefillUserData?: ClientUserData;
  open: boolean;
  setOpen: (v: boolean) => void;
  onEventScheduled?: (evUri: string) => void;
}

enum EventName {
  CALENDLY_OPENED = "calendly_opened",
  DATETIME_SELECTED = "datetime_selected",
  APPT_SUBMITTED = "appt_submitted",
}

const calendlySettings = {
  backgroundColor: "ffffff",
  hideEventTypeDetails: false,
  hideLandingPageDetails: false,
  primaryColor: "00a2ff",
  textColor: "4d5055",
};

export const CalendlyPopup = ({
  url,
  prefillUserData,
  open,
  setOpen,
  onEventScheduled,
}: CalendlyPopupProps) => {
  useCalendlyEventListener({
    onEventScheduled: async (ev: EventScheduledEvent) => {
      onEventScheduled?.(ev?.data?.payload?.event?.uri);
    },
  });

  const prefillData = prefillUserData
    ? {
        email: prefillUserData.email || undefined,
        phone: prefillUserData.phone || undefined,
        firstName: prefillUserData.firstName || undefined,
        lastName: prefillUserData.lastName || undefined,
        name:
          prefillUserData.firstName && prefillUserData.lastName
            ? `${prefillUserData.firstName} ${prefillUserData.lastName}`
            : undefined,
      }
    : undefined;

  return (
    <PopupModal
      url={url}
      rootElement={document.getElementById("root")!}
      onModalClose={() => setOpen(false)}
      pageSettings={calendlySettings}
      prefill={prefillData}
      open={open}
    ></PopupModal>
  );
};
